import styled from 'styled-components';

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 0;
  background: transparent;
  img {
    width: 90px;
    height: auto;
  }
`;
